import React from "react";
import routes from "../../consts/routes.json";
import EANavButton from "../EANavButton";

/**
 * Komponente, welche nach erfolgreicher Registrierung angezeigt wird.
 * @param email Die E-Mail Adresse des neu registrierten Nutzers
 * @returns {JSX.Element}
 * @constructor
 */
function RegistrationSuccessComponent({ email }) {
    return (
        <div style={{ padding: "var(--vertical-spacing) var(--horizontal-spacing)" }}>
            <h1>Registrierung erfolgreich abgeschlossen</h1>
            <p id="Registrationserfolgsmeldung">
                Ihnen wird eine E-Mail mit allen weiteren Informationen an <strong>{email}</strong> gesendet.
                <br />
                Nachdem Sie die Registrierung über die E-Mail bestätigt haben, können Sie sich erst einloggen, nachdem ein Administrator
                Ihnen den Zugang zur Anwendung erlaubt hat.
            </p>
            <br />
            <br />
            <EANavButton to={routes.LOGIN}>Zum Login</EANavButton>
        </div>
    );
}

export default RegistrationSuccessComponent;
